/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerForgotPasswordResponse } from "./MemberManagerForgotPasswordResponse";

export type MemberManagerForgotPasswordResponseApiRespoonse = {
  data?: MemberManagerForgotPasswordResponse;
  status?: MemberManagerForgotPasswordResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerForgotPasswordResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
